import { useFormContext } from 'react-hook-form';

interface SCFormFieldSCValueProps {
  name: string;
  value: any;
}

function SCFormFieldSCValue({ name, value }: SCFormFieldSCValueProps) {
  const { register } = useFormContext();
  return <input value={value} {...register(name)} style={{ display: 'none' }} />;
}

export { SCFormFieldSCValue };
